import React, {useEffect, useState} from "react";
import queryString from "query-string";
import Score from "./Score";
import Comments from "./Comments";
import {callApi} from "../../../connection/ClientApi";
import Urls from "../../../connection/Urls";
import messages from "res/messages/farsi";
import Pagination from "components/list/Pagination";
import {useHistory} from "react-router-dom";
import TitleAddHeader from "../address/TitleAddHeader";
import ICBackIcon from "res/images/back.png";
import {Helmet} from "react-helmet";

export default function CommentList(props) {
    const urlParams = queryString.parse(props.location.search)
    const history = useHistory();
    const [commentList, setCommentList] = useState([])
    const [pages, setPages] = useState([]);
    const [limit] = useState(6);

    const pushToHistory = (p) => {
        let product_id = (urlParams ? urlParams.v : undefined)
        if (product_id) {
            props.onNavigate(history, 'commentList?v=' + product_id + '&p=' + p)
        }
    }
    const onNumberClick = (number) => {
        pushToHistory(number)
    }
    const onNextClick = () => {
        pushToHistory((parseInt(urlParams.p) + 1))
    }

    const onBackClick = () => {
        pushToHistory((parseInt(urlParams.p) - 1))
    }

    const requestCommentsCount = () => {
        let product_id = (urlParams ? urlParams.v : undefined)

        if (product_id) {
            let params = new FormData();
            params.append("product_id", product_id);
            callApi(Urls.getProductCommentsCount, params, (data) => {
                if (data.result === 'success') {
                    let number = data.response / limit;
                    if (data.response % limit > 0) {
                        number++
                    }
                    let tempPages = []
                    for (let i = 1; i <= number; i++) {
                        tempPages.push({
                            number: i,
                            selected: i === parseInt(urlParams.p)
                        })
                    }
                    setPages(tempPages)
                }

            }, () => {
                props.onAlert(messages.responseCodeIsNot200)
            }, () => {
                props.onLoading(true)
            }, () => {
                props.onLoading(false)
            })
        }
    }


    useEffect(() => {
        requestGetComments()
        requestCommentsCount()
    }, [props.location.search])

    function requestGetComments() {
        let product_id = (urlParams ? urlParams.v : undefined)

        if (product_id) {
            let params = new FormData();
            params.append("product_id", product_id);
            params.append("limit", limit);
            params.append("page", (urlParams && urlParams.p) ? urlParams.p : 1)
            callApi(Urls.getProductComments, params, (data) => {
                if (data && data.result === 'success' && data.response.list && data.response.list.length > 0) {
                    setCommentList(data.response)
                }
            }, () => {
                props.onAlert(messages.responseCodeIsNot200)
            }, () => {
                props.onLoading(true)
            }, () => {
                props.onLoading(false)
            })
        }

    }

    return (<>
        <Helmet>
            <title>ØµØ±ÙÙ ÙØ§Ø±Ú©Øª - ÙÛØ³Øª ÙØ¸Ø±Ø§Øª</title>
            <meta property="og:image" content="%PUBLIC_URL%/favicon.ico"/>
            <meta property="og:url" content="https://sarfemarket.ir/"/>
            <meta name="google-site-verification" content="a7UDcP_j_QBlp1S7KGeczLTlvDmYkzvwyBo7Qa-qbH0"/>
        </Helmet>
        {commentList && commentList.list && commentList.score && commentList.product_id && commentList.count && commentList.suggest ?
            <div className="fullWidth paddingTopSmall">
                <TitleAddHeader
                    icon={ICBackIcon}
                    title={messages.return}
                    onIconClick={() => {
                        props.onNavigate(history, '/productDetail?v=' + commentList.product_id)
                    }}/>
                <div className="card marginLeftRightSmall marginTopMedium"
                     style={{minHeight: "15em", marginTop: '0.1rem'}}>
                    <Score score={commentList.score} {...props} product_id={commentList.product_id}
                           count={commentList.count} suggest={commentList.suggest}/>
                </div>
                <Comments {...props} comments={commentList.list} full={true} showDate={true} seeAll={false}
                          openImage={true} product_id={commentList.product_id}/>
                {(commentList.list.length > 0 && pages.length > 1) &&
                    <div style={{float: "right"}}>
                        <br/>
                        <Pagination
                            pages={pages}
                            onNumberClick={onNumberClick}
                            onNextClick={onNextClick}
                            onBackClick={onBackClick}/>

                    </div>
                }


            </div> : <div></div>}

    </>)
}